/**
 * @flow
 */
import { observable, action, runInAction } from 'mobx';
import {handleLowPriceData} from './util';

import qhotdog from '../../common/hysdkUtils/request';
import { QToast } from '@qnpm/q-components';
import {getQueryParam} from "../search/util";

import {getItemSync} from '../../common/StorageUtils';
import {logPageTime} from "../../common/utils";


export default class CheapTicketModel{
    @observable.ref lowPriceData = {}; // 请求到的处理后的数据
    @observable.ref anchor = '';
    @observable.ref selectedFilter = '';
    @observable.ref tabFixed ='';
    @observable.ref loading = false;
    @observable.ref lowPriceDepCity = getQueryParam('depCity') || getItemSync('curLocation') || '北京';
    @observable.ref searchFilterModalVisible = false;
    @observable.ref firstGetLowPriceData = false;
    @observable.ref fixedSearchBoxVisible = false;
    @observable.ref successToast;
    @observable.ref error = false;
    @observable.ref tabXMap = false;
    @observable.ref firstReq = true;

    constructor(rootStore) {
        this.rootStore = rootStore;

        this.req = {
            locationCity: this.lowPriceDepCity,
            simpleData: 'yes'
        };
    }

    @action.bound
    setTabFixed(tabFixed) {
        this.tabFixed = tabFixed;
    }

    @action.bound
    setLowPriceDepCity(city) {
        this.lowPriceDepCity = city;
        this.setLocation(city);
    }
    @action.bound
    setTabXMap(tabXMap){
        this.tabXMap = tabXMap
    }

    @action.bound
    async setLocation(locationCity){
        if(!location) {
            return;
        }
        this.req.locationCity = locationCity;
        let {holiday, simpleData} = this.req || {};
        await this.fetchData({
            locationCity,
            holiday,
            simpleData
        }, locationCity)
    }

    @action.bound
    setAnchor(anchor) {
        if(!anchor) {
            return;
        }
        this.anchor = anchor;
    }

    @action.bound
    async setFilter(filter){
        if(!filter) {
            return;
        }
        this.selectedFilter = filter;

        let {locationCity, simpleData} = this.req || {};
        await this.fetchData({
            simpleData,
            locationCity,
            holiday: filter
        }, filter)
    }


    @action.bound
    handleSearchFilterModal = (type) => {
        this.searchFilterModalVisible = type === 'show'
    };

    @action.bound
    handleFixedSearchBox = (type) => {
        this.fixedSearchBoxVisible = type === 'show'
    };


    @action.bound
    async fetchData(param, change, firstReq) {
        param = param || this.req;
        let cat = getQueryParam('cat');
        try {
            this.firstReq = firstReq;
            this.loading = true;
            this.error = false;

            GodEye.log({
                r: 'req_airline_total'
            });

            let response;
            if(firstReq && window.preAirlinePromise){
                response = await window.preAirlinePromise;
            } else {
                response = await qhotdog({
                    url: '/lowFlightInterface/api/getAirline',
                    isSignature: true,
                    method: 'POST',
                    requestType: 'json',
                    timeout: 6000,
                    body: {...param, t: 'f_urInfo_page_superLow', cat: cat ? cat  + '_lowFlight-cheap-ticket' : 'lowFlight-cheap-ticket'}
                });
            }

            const { data, sys } = response || {};
            this.successToast = '';

            if(firstReq) {
                logPageTime({r: 'datastart', time: window.__index_data_start - window.__root_time});
                logPageTime({r: 'dataend', time: new Date().getTime() - window.__root_time});
                if (sys) {
                    const {startTime, endTime} = sys || {};
                    logPageTime({r: 'datacost', time: endTime - startTime})
                }
            }

            if(data && data.items && data.items.length && data.filters){
                runInAction(() => {
                    // 保存booking数据
                    this.lowPriceData = handleLowPriceData(data);
                    this.loading = false;
                    !firstReq && change && QToast.show(`已为您切换${change}的低价`, {
                        strategy: 1,
                        position: 2
                    });
                    if(!this.firstGetLowPriceData) {
                        this.firstGetLowPriceData = true;
                        this.selectedFilter = this.lowPriceData.filters[0].title
                    }
                    GodEye.log({
                        r: 'req_airline_success'
                    });
                });
            } else {
                this.error = true;
                this.loading = false;
                this.lowPriceData = {};
                GodEye.log({
                    r: 'req_airline_fail'
                });
            }


        } catch (e) {
            GodEye.log({
                r: 'req_airline_error',
                e: JSON.stringify(e),
                errMsg: e ? e.message : e
            });
            this.error = true;
            this.loading = false;
            this.lowPriceData = {};
        }
    }

}
